import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalController, NavController } from '@ionic/angular';
import { ThemeService } from 'src/app/services/client/theme/theme.service';
@Component({
  selector: 'homie-booking-success-modal',
  templateUrl: './homie-booking-success-modal.component.html',
  styleUrls: ['./homie-booking-success-modal.component.scss'],
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class HomieBookingSuccessModal implements OnInit {
  @Input() bookingReferenceId: any;
  @Input() priceDetail: any;

  constructor(
    private modalController: ModalController,
    private navController: NavController,
    private theme: ThemeService
  ) {}

  ngOnInit() {}

  closeModal() {
    this.modalController.dismiss();
  }

  navigateToHome() {
    this.closeModal();
    this.navController.navigateRoot([`/booking-complete/${this.bookingReferenceId}`]);
  }
  help() {
    this.closeModal();
    this.navController.navigateRoot([`/customer-support/${this.bookingReferenceId}`]);
  }
}
